import React from 'react';
import { FaMusic } from 'react-icons/fa';
import SpotifyUserCard from './SpotifyUserCard';
import EmptyUserCard from './EmptyUserCard';
import { HOME_TEXTS, APP_BUTTON_STYLES } from './constants';

/**
 * Props pour le composant SpotifyAppCard
 * @typedef {Object} SpotifyAppCardProps
 * @property {Object|null} spotifyApp - L'application Spotify de l'utilisateur
 * @property {Object|null} spotifyUser - L'utilisateur Spotify connecté
 * @property {Function} onProfile - Fonction appelée pour naviguer vers le profil
 * @property {Function} onLogout - Fonction appelée pour se déconnecter de Spotify
 * @property {Function} onEdit - Fonction appelée pour éditer l'application
 * @property {Function} onSetup - Fonction appelée pour créer une nouvelle application
 */

/**
 * Composant de carte pour l'application Spotify
 * Affiche soit une carte avec les informations de l'application, soit une carte vide pour créer une nouvelle application
 *
 * @component
 * @param {SpotifyAppCardProps} props - Les props du composant
 * @returns {JSX.Element} La carte de l'application Spotify
 */
const SpotifyAppCard = ({
  spotifyApp,
  spotifyUser,
  onProfile,
  onLogout,
  onEdit,
  onSetup,
}) => {
  if (spotifyApp && (!spotifyApp.isSystemApp || spotifyUser)) {
    return (
      <SpotifyUserCard
        user={{
          id: spotifyApp.id,
          display_name: spotifyApp.isSystemApp
            ? spotifyApp.spotifyUser?.display_name || spotifyApp.appName
            : spotifyApp.appName,
          login: spotifyApp.isSystemApp
            ? spotifyApp.spotifyUser?.id || spotifyApp.appName
            : spotifyApp.appName,
          appType: 'spotify-app',
        }}
        onNavigateProfile={onProfile}
        onLogout={onLogout}
        onEdit={onEdit}
        isAppCard={true}
        appData={spotifyApp}
        spotifyUser={spotifyApp.spotifyUser}
      />
    );
  }

  return (
    <EmptyUserCard
      platform="SpotifyApp"
      icon={FaMusic}
      title={HOME_TEXTS.SPOTIFY_APP.TITLE}
      description={HOME_TEXTS.SPOTIFY_APP.DESCRIPTION}
      buttonText={HOME_TEXTS.SPOTIFY_APP.BUTTON}
      onLogin={onSetup}
      buttonStyle={APP_BUTTON_STYLES.SPOTIFY}
    />
  );
};

export default SpotifyAppCard;
